import { getAuthAxiosInstance } from '../../../../../common/services/axios-config';
import IUserFormData from '../../user-form/interfaces/IUserFormData';
import InternalUserTypes from '../enums/internal-user-types.enum';

import ThirdUserTypes from '../enums/third-user-types.enum';
import UserAccountType from '../enums/user-account-type.enum';
import IGetUserResponse from '../interfaces/IGetUserResponse';
import IUpdateUserRequestRequest from '../interfaces/IUpdateUserRequest';
import IUpdateUserResponse from '../interfaces/IUpdateUserResponse';

const TranslateUserTypesLabel = (
    index: number,
    userAccountType: UserAccountType,
): string => {
    let label = '';
    if (userAccountType === UserAccountType.internal) {
        label = InternalUserTypes[Number(index)];
    } else {
        label = ThirdUserTypes[Number(index)];
    }

    switch (label) {
        case ThirdUserTypes[0]:
            return 'Operador Transportadora';
        case ThirdUserTypes[1]:
            return 'Admin. Transportadora';
        case InternalUserTypes[2]:
            return 'Solicitante';
        case InternalUserTypes[3]:
            return 'Operação';
        case InternalUserTypes[4]:
            return 'Admin. Mesa';
        case InternalUserTypes[5]:
            return 'Sula';
        default:
            return '';
    }
};

const getUserById = async (
    userId: string,
    t: (key: string) => string, // função de tradução
): Promise<IUserFormData> => {
    const api = await getAuthAxiosInstance();

    const response = await api
        .get<IGetUserResponse>(`v1/users/${userId}`)
        .catch(() => {
            throw new Error(t('ErroConsultarUsuario'));
        });

    if (response.data) {
        const user = response.data;

        const data: IUserFormData = {
            name: user.name,
            email: user.email,
            userCarrier: user.carrier,
            type: user.type,
            systems: [
                {
                    id: 'ontime-leilao',
                    label: 'OnTime Leilão',
                    number: 0,
                    isChecked:
                        user.userAllowedSystems.find(
                            ({ sulaSystem }) => sulaSystem === 0,
                        )?.isAllowed ?? false,
                },
                {
                    id: 'smart-cargas',
                    label: 'Smart Cargas',
                    number: 1,
                    isChecked:
                        user.userAllowedSystems.find(
                            ({ sulaSystem }) => sulaSystem === 1,
                        )?.isAllowed ?? false,
                },
            ],
        };
        return data;
    }

    return {} as IUserFormData;
};

const updateUser = async (
    userId: string,
    user: IUserFormData,
    t: (key: string) => string,
    isRequestByThird: boolean = false,
): Promise<IUpdateUserResponse> => {
    const api = await getAuthAxiosInstance();

    const request = {
        name: user.name,
        type: Number.parseInt(user.type, 10),
        userAllowedSystems: user.systems.map(system => ({
            sulaSystem: system.number.toString(),
            isAllowed: system.isChecked,
        })),
    } as IUpdateUserRequestRequest;

    if (user.userCarrier) {
        request.carrier = {
            carrierId: user.userCarrier?.carrierId,
            name: user.userCarrier?.name,
            sulaHubId: user.userCarrier?.sulaHubId,
        };
    }

    const response = await api
        .put(
            isRequestByThird
                ? `v1/users/${userId}:third`
                : `v1/users/${userId}`,
            request,
        )
        .catch((error: any) => {
            if (error?.response?.status === 422) {
                throw new Error(t('RequisicaoExistenteUsuario'));
            }

            throw new Error(t('ErroTentativaAtualizarUsuario'));
        });

    return response.data;
};

const UserEditFormService = {
    getUserById,
    updateUser,
    TranslateUserTypesLabel,
};

export default UserEditFormService;
